import { AlertBanner } from '@/app/_components/AlertBanner/index.jsx'
import { Gutter } from '@/app/_components/Gutter/index.jsx'

import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'

export const alertBannerBlockFragment = cmsGraphql(/* GraphQL */ `
  fragment alertBannerBlockFragment on CmsAlertBannerBlock {
    alert {
      richText
      intent
    }
  }
`)

export const alertBannerBlockTypename = 'CmsAlertBannerBlock'

export type AlertBannerBlockProps = {
  data: FragmentType<typeof alertBannerBlockFragment>
  isNested?: boolean
}

export const AlertBannerBlock = ({ data }: AlertBannerBlockProps) => {
  const { alert } = getFragmentData(alertBannerBlockFragment, data)

  if (!alert || !alert.richText) {
    return null
  }

  return (
    <Gutter className="my-200 px-0">
      <AlertBanner {...alert} />
    </Gutter>
  )
}
